import { render, staticRenderFns } from "./InternationalWireAccount.vue?vue&type=template&id=3d3b6794&"
import script from "./InternationalWireAccount.vue?vue&type=script&lang=js&"
export * from "./InternationalWireAccount.vue?vue&type=script&lang=js&"
import style0 from "./InternationalWireAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports